export default "__VITE_ASSET__5e89fb94__"